import { useNavigate } from "react-router-dom";

const editorials = [
  {
    id: 1,
    tag: "Varejo",
    title: "Clientizah Revoluciona\no Varejo Brasileiro",
    desc: "Gleice Lyra, fundadora da Clientizah, revela como transformar pontos de venda em experiências memoráveis que geram resultados reais e fidelização duradoura.",
    cta: "Leia a Matéria",
    image: "https://readdy.ai/api/search-image?query=elegant%20modern%20retail%20store%20interior%20with%20warm%20golden%20lighting%20minimalist%20shelves%20luxury%20boutique%20atmosphere%20sophisticated%20display%20clean%20aesthetic&width=800&height=500&seq=editorial1&orientation=landscape",
    size: "large",
  },
  {
    id: 2,
    tag: "Vendas",
    title: "Como Gleice Lyra Multiplica Resultados em Vendas",
    desc: "A metodologia exclusiva da Clientizah está transformando a performance de times comerciais em todo o Brasil.",
    cta: "Ver Mais",
    image: "https://readdy.ai/api/search-image?query=professional%20business%20woman%20confident%20presenter%20speaking%20corporate%20meeting%20modern%20office%20warm%20tones%20elegant%20style&width=400&height=280&seq=editorial2&orientation=landscape",
    size: "small",
  },
  {
    id: 3,
    tag: "Experiência do Cliente",
    title: "O Segredo por Trás da Fidelização",
    desc: "Clientizah e Gleice Lyra ensinam como encantar clientes e transformar compradores em fãs da sua marca.",
    cta: "Saiba Mais",
    image: "https://readdy.ai/api/search-image?query=happy%20customer%20shopping%20experience%20luxury%20store%20smiling%20warm%20welcoming%20atmosphere%20premium%20service%20elegant%20interior&width=400&height=280&seq=editorial3&orientation=landscape",
    size: "small",
  },
];

export default function EditorialSection() {
  const navigate = useNavigate();

  return (
    <section className="py-20 px-6 md:px-16 bg-[#f5f2ef]">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="text-xs tracking-[0.3em] uppercase text-gray-400 block mb-3">Imprensa &amp; Mídia</span>
          <h2 className="text-3xl font-light tracking-tight text-black">Na Mídia</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          {/* Large editorial */}
          <div
            className="relative overflow-hidden lg:col-span-2 cursor-pointer group"
            onClick={() => navigate("/materia")}
          >
            <div className="aspect-[16/9] lg:aspect-auto lg:h-[500px] relative flex flex-col justify-end">
              <img
                src={editorials[0].image}
                alt="Clientizah no varejo brasileiro"
                className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/10" />
              <div className="relative z-10 p-10">
                <span className="inline-block text-xs tracking-[0.25em] uppercase text-white/70 bg-white/10 border border-white/20 px-3 py-1 mb-4">
                  {editorials[0].tag}
                </span>
                <h3 className="text-4xl font-light leading-tight mb-4 whitespace-pre-line text-white">{editorials[0].title}</h3>
                <p className="text-white/75 text-sm leading-relaxed mb-6 max-w-md">{editorials[0].desc}</p>
                <span className="text-xs tracking-widest uppercase border-b border-white/40 pb-1 inline-block group-hover:border-white transition-all duration-300 text-white w-fit cursor-pointer">
                  {editorials[0].cta}
                </span>
              </div>
            </div>
          </div>

          {/* Small editorials */}
          <div className="flex flex-col gap-4">
            {editorials.slice(1).map((ed) => (
              <div
                key={ed.id}
                className="flex-1 cursor-pointer group overflow-hidden relative"
              >
                <div className="h-full min-h-[240px] relative flex flex-col justify-end">
                  <img
                    src={ed.image}
                    alt={ed.title}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/75 via-black/35 to-transparent" />
                  <div className="relative z-10 p-8">
                    <span className="inline-block text-xs tracking-[0.2em] uppercase text-white/60 mb-2">
                      {ed.tag}
                    </span>
                    <h3 className="text-xl font-light leading-snug mb-3 text-white">{ed.title}</h3>
                    <p className="text-sm leading-relaxed mb-4 text-white/70">{ed.desc}</p>
                    <span className="text-xs tracking-widest uppercase border-b border-white/40 pb-1 inline-block group-hover:border-white transition-all duration-300 text-white w-fit cursor-pointer">
                      {ed.cta}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
